import React, { useContext, useState, useCallback } from "react";

import { InfiniteScroll } from "../../components";
import AlertItem from "./AlertItem";

const AlertList = ({
  list = "default",
  query = "",
  filters = {},
  firstPageOnly = false,
  maxItemsCount,
  sort = { field: "refreshed_at", direction: "desc" },
  limit,
  onResultsLoaded,
  itemComponent, // RC grid pages pass RCAlertCard; legacy pages keep AlertItem
  itemComponentProps = {},
  children = null, // Displayed after the last watch
}) => {
  const ItemComponent = itemComponent || AlertItem;
  const [refreshKey, setRefreshKey] = useState(0);

  const fetchParams = {
    list,
    query,
    filters,
    sort,
  };

  const handleItemUpdate = useCallback(() => {
    setRefreshKey((prev) => prev + 1);
  }, []);

  return (
    <InfiniteScroll
      key={refreshKey}
      fetchUrl="/api/buy-alerts/search"
      fetchParams={fetchParams}
      firstPageOnly={firstPageOnly}
      maxItemsCount={maxItemsCount}
      emptyMessage="No products found."
      onResultsLoaded={onResultsLoaded}
      fetchLimit={limit || 8}
    >
      {({ items, isLoading, hasMore }) => (
        <div className="row">
          {items.length > 0 &&
            items.map((alert) => (
              <ItemComponent
                key={alert.id}
                alert={alert}
                handleItemUpdate={handleItemUpdate}
                {...itemComponentProps}
              />
            ))}

          {!isLoading && items.length === 0 && (
            <div className="no-results">
              <p>No Buy Alerts found.</p>
            </div>
          )}

          {!hasMore && children}
        </div>
      )}
    </InfiniteScroll>
  );
};

export default AlertList;
